<template>
	<div v-if="current==0">>
		<van-tabbar v-model="active">
			<!-- <van-tabbar-item>
				<span>手术视频</span>
				<template #icon="props">
					<img :src="icon.video" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>资讯</span>
				<template #icon="props">
					<img :src="icon.article" />
				</template>
			</van-tabbar-item> -->
			<van-tabbar-item>
				<span @click="showCodeContent()">公众号</span>
				<template #icon="props">
					<img :src="icon.qrcode" @click="showCodeContent()"/>
				</template>
			</van-tabbar-item>
			<!-- <van-tabbar-item>
				<span><a href="http://mail.kingstronbio.com/" target="_blank">员工</a></span>
				<template #icon="props">
					<a href="http://mail.kingstronbio.com/" target="_blank"><img :src="icon.staff" /></a>
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span><a href="https://sso.dinghuo123.com/login" target="_blank">代理商</a></span>
				<template #icon="props">
					<a href="https://sso.dinghuo123.com/login" target="_blank"><img :src="icon.agent" /></a>
				</template>
			</van-tabbar-item> -->
		</van-tabbar>
		<van-popup class="detail-box btm-box" v-model="isShowCode" :overlay="false" closeable :get-container="getContainer"  @click-close-icon="onClickCloseIcon">
			<img  src="../../../static/code.jpg" @click="isShowCode= false"/>
		</van-popup>
	</div>
	
</template>

<script>
export default {
	props: {
		current: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			active: 0,
			icon: {
				video: require("../../../static/m/common/tabbar-video.png"),
				article: require("../../../static/m/common/tabbar-article.png"),
				qrcode: require("../../../static/m/common/tabbar-qrcode.png"),
				staff: require("../../../static/m/common/tabbar-staff.png"),
				agent: require("../../../static/m/common/tabbar-agent.png"),
			},
			isShowCode: false,
		};
	},
	methods: {
		getContainer() {
			return document.querySelector('.m-pageSwiper');
		},
		showCodeContent(){
			this.isShowCode = true;
			this.$parent.isHideNav = true;
		},
		onClickCloseIcon(){
			this.isShowCode = false;
			this.$parent.isHideNav = false;
		}
	}
};
</script>

<style lang="less">
@import '../../assets/css/index';
.van-tabbar {
	width: 1088/@r;
	height: 169/@r;
	left: 50%;
	transform: translateX(-50%);
	margin-bottom: 22/@r;
	border-radius: 50/@r;
	overflow: hidden;
}
.van-tabbar:before, .van-tabbar::after {
	border: 0;
}
.van-tabbar-item, .van-tabbar-item--active,a {
	color: #4d4d4d;
	.van-tabbar-item__icon {
		margin-bottom: 10px;
	}
	img{
		.scale(89,69);
	}
}
.btm-box {
	background-color: #000;
	width:100% !important;
	height:100%;
	display: block;
	/deep/.van-popup__close-icon {
		font-size: 30px;
		color:#4d4d4d;
	}
	img{
		width: 580/@r;
		.pos-center();
	}
}
</style>
